<template>
  <div >
    <!-- <div style="width: 100%; height: 174px"></div>
      <div class="yellow-line"></div>
      <p class="title">社群组织的 <br />智慧管理倡导者</p>
      <p class="text">
        用先进技术，高效管理社群组织，解决成员管理、活<br />动管理、捐赠管理难的痛点，轻松运营你的社群。
      </p>
      <div class="free-use" @click="$router.push('/login')">获取方案</div>
      <div class="img1-text">地方校友会</div>
      <div class="img2-text">校友总会</div>
      <div class="img3-text">院系校友会</div>
      <div class="img4-text">教育基金会</div>
       <img
        class="img1"
        src="https://album.usho.cn/www/upload/90de3bb7bf1f82eb02ef72512a39da27.png?imageView2/1/w/330/h/330/q/80"
        alt=""
      />
      <img
        class="img2"
        src="https://album.usho.cn/www/upload/fb9edb590cd43114f4166cc53de10115.png?imageView2/1/w/330/h/330/q/80"
        alt=""
      />
      <img
        class="img3"
        src="https://album.usho.cn/www/upload/fc6f098a97b215dd0d78864d7ac1d3c4.png?imageView2/1/w/330/h/330/q/80"
        alt=""
      />
      <img
        class="img4"
        src="https://album.usho.cn/www/upload/daa757ba860b04c6c081f8e2279583bd.png?imageView2/1/w/330/h/330/q/80"
        alt=""
      /> -->
    <div v-if="is_pc && img_list.length">
      <div class="index_photo">
        <img class="index_photo_banner" :src="img_list[6].img_path" alt="">
        <img class="index_photo_gif" :src="gif_src" alt="">
        <div @click="dialogClick('聚合页')">获取方案</div>
      </div>
      <div class="index_photo1" ref="dxxyzh">
        <img :src="img_list[7].img_path" alt="">
        <!-- <div class="index_photo1_title">大学校友总会</div>
        <div class="info1">
          <span>210多项功能，包括</span>
          <p>·校友数据库，全球校友会网络，找回校友</p>
          <p>·云校庆，校友活动，校友卡</p>
          <p>·找校友，校友捐赠，校友企业，知名校友</p>
        </div>
        <div class="info2">
          <span>400多客户，如</span>
          <p>浙江大学，云南大学，江苏大学，中国美院</p>
        </div> -->
        <div class="get_programme" @click="dialogClick('大学校友总会')">获取方案</div>
      </div>
      <div class="index_photo2" ref="jyjjh">
        <img :src="img_list[8].img_path" alt="">
        <!-- <div class="index_photo2_title">教育基金会</div>
        <div class="info1">
          <span>180多项功能，包括</span>
          <p>·捐赠项目管理，捐赠人管理，受益人管理</p>
          <p>·温柔催捐，感恩桥，校庆捐赠，图书捐赠</p>
          <p>·树木捐赠，云捐步，桌椅捐赠</p>
        </div>
        <div class="info2">
          <span>120多客户，如</span>
          <p>华东政法大学，东南大学，河北师范大学</p>
          <p>西南政法大学，甘肃民勤一中</p>
        </div> -->
        <div class="get_programme" @click="dialogClick('教育基金会')">获取方案</div>
      </div>
      <div class="index_photo1" ref="zxxxq">
        <img :src="img_list[9].img_path" alt="">
        <!-- <div class="index_photo1_title">中小学校庆 校友会 教育基金会</div>
        <div class="info1">
          <span>150多项功能，包括</span>
          <p>·校庆策划，校庆新媒体运营，全球校友会网络</p>
          <p>·返校活动，校庆返校报名，校庆云祝福，云校庆，云合影，点亮地图</p>
          <p>·图书捐赠，树木捐赠，桌椅捐赠，云捐步</p>
        </div>
        <div class="info2">
          <span>50多客户，如</span>
          <p>浙江东阳中学，金华一中，湖南浏阳市第三中</p>
        </div> -->
        <div class="get_programme" @click="dialogClick('中小学校庆')">获取方案</div>
      </div>
      <div class="index_photo2" ref="dfxyh">
        <img :src="img_list[10].img_path" alt="">
        <!-- <div class="index_photo2_title">地方校友会 校友经济联盟</div>
        <div class="info1">
          <span>160多项功能，包括</span>
          <p>·校友数据库，建立校友组织，建立校友经济联盟</p>
          <p>·发起活动，活动纳新</p>
          <p>·校友联络互助，收取会费，校友会商城，相册和视频，理事会</p>
        </div>
        <div class="info2">
          <span>50多客户，如</span>
          <p>杭州浙江大学校友会，浙江省中国科技大学校友会</p>
          <p>上海浙大校友会，上海南京航空航天大学校友会</p>
        </div> -->
        <div class="get_programme" @click="dialogClick('地方校友会')">获取方案</div>
      </div>
      <div class="index_photo1" ref="yxxxh">
        <img :src="img_list[11].img_path" alt="">
        <!-- <div class="index_photo1_title">院系校友会</div>
        <div class="info1">
          <span>160多项功能，包括</span>
          <p>·校友数据库，建立院系校友会，建立各地校友分会</p>
          <p>·返校活动，院系庆典</p>
          <p>·校友互助合作，校友企业，知名校友，校友捐赠</p>
        </div>
        <div class="info2">
          <span>30多客户，如</span>
          <p>浙江大学医学院，浙大电机学院，广西大学法学院</p>
        </div> -->
        <div class="get_programme" @click="dialogClick('院系校友会')">获取方案</div>
      </div>
    </div>
    <div v-if="!is_pc && img_list.length">
      <div style="height: 5.02rem;" ></div>
      <div class="p_index" >
        <img class="p_index_logo" src="https://pics.usho.cn/20241014/1728871839.gif" alt="">
        <img class="p_index_bg" :src="img_list[0].img_path" alt="">
        <div @click="dialogClick('聚合页')">获取方案</div>
      </div>
      <div class="p_index1" >
        <img class="p_index_bg" :src="img_list[1].img_path" alt="">
        <div @click="dialogClick('大学校友总会')">获取方案</div>
      </div>
      <div class="p_index1" >
        <img class="p_index_bg" :src="img_list[2].img_path" alt="">
        <div @click="dialogClick('教育基金会')" style="bottom: 1.08rem;">获取方案</div>
      </div>
      <div class="p_index1" >
        <img class="p_index_bg" :src="img_list[3].img_path" alt="">
        <div @click="dialogClick('中小学校庆')" style="bottom: 1.08rem;">获取方案</div>
      </div>
      <div class="p_index1" >
        <img class="p_index_bg" :src="img_list[4].img_path" alt="">
        <div @click="dialogClick('地方校友会')" style="bottom: 0.93rem;">获取方案</div>
      </div>
      <div class="p_index1" >
        <img class="p_index_bg" :src="img_list[5].img_path" alt="">
        <div @click="dialogClick('院系校友会')" style="bottom: 1.29rem;">获取方案</div>
      </div>
    </div>
    <!-- <div class="banner-style">
      <el-carousel
        :interval="5000"
        height="700px"
        class="el-carousel"
        arrow="hover"
      >
      
        <el-carousel-item>
          <img
            src="https://album.usho.cn/www/upload/52552469e6c1842c39cda5dfeeb48793.png?imageView2/1/q/80"
            alt=""
          />

          <img style="position: absolute;left: 10%;top: 100px;width: 266px;height: 275px;" src="https://album.usho.cn/www/upload/45dd78c7c854e1ebe94474675ef6edcf.png" alt="友笑社汇、社汇官网首页、社汇校友管理系统、友笑校友会平台、社汇校友小程app、社汇校友服务平台、社汇校友平台">
        </el-carousel-item>

        <el-carousel-item>
          <img
            src="https://album.usho.cn/www/upload/2b4b9bb2cf874fd39535d295988b377e.png?imageView2/1/q/80"
            alt=""
          />
        </el-carousel-item>

        <el-carousel-item>
          <img
            src="https://album.usho.cn/www/upload/17ada89074b3c52d0743745822024c5b.png?imageView2/1/q/80"
            alt=""
          />
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="https://album.usho.cn/www/upload/cb1cf0d7581da71591fbe927e86d28dc.png?imageView2/1/q/80"
            alt=""
          />
        </el-carousel-item>
      </el-carousel>
    </div> -->

    <!-- <div class="banner">
      <div class="content-flex">
        <div class="flex-one">
          <img src="https://album.usho.cn/www/upload/f25f1f20c6e23f83e1342b0eb4675950.png" alt="" />
          <p class="title-small">时光影像馆</p>
          <div class="text">
            搭建班级专属的线上私密空间，记录班级大事件和精彩瞬间
          </div>
          <div class="ljsy" style="width: 100%">
            <div
              class="ljsy-two"
              style="background: #31CEC2;"
              @click="dialogClick('时光影像馆报名试用')"
            >
              获取方案
            </div>
          </div>
        </div>
        <div
          style="width: 0.1px; height: 217px; border: 1px solid #ebebeb"
        ></div>
        <div class="flex-two">
          <img src="https://album.usho.cn/www/upload/9135510c0049f133d378426ac8dc17e5.png" alt="" />
          <p class="title-small">线上捐赠</p>
          <div class="text">
            提供便捷的捐赠项目管理工具，安全稳定有保障
          </div>
          <div class="ljsy" style="width: 100%">
            <div
              class="ljsy-one"
              style="background: #FFA43B;"
              @click="dialogClick('线上捐赠报名试用')"
            >
              获取方案
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; justify-content: center">
        <div class="item" style="margin-left: 0">
          <img
            class="item-img"
            src="https://album.usho.cn/www/upload/6c3682517fde8c183adace7e9685876b.png?imageView2/1/q/40"
            alt=""
          />
          <span class="item-text">
            <span class="item-num">{{ changeNum(num1) }}</span>
            <span class="add"></span> <span class="item-unit">所</span> <br />
            合作机构</span
          >
        </div>
        <div class="item">
          <img
            class="item-img"
            src="https://album.usho.cn/www/upload/af2a05f26ad57a06e0daf8af5060daa0.png?imageView2/1/q/40"
            alt=""
          />
          <span class="item-text">
            <span class="item-num">{{ changeNum(num2) }}</span>
            <span class="add"></span> <span class="item-unit">场</span> <br />
            活动</span
          >
        </div>
        <div class="item">
          <img
            class="item-img"
            src="https://album.usho.cn/www/upload/833e3b9db75364d8efba5127d0e16495.png?imageView2/1/q/40"
            alt=""
          />
          <span class="item-text">
            <span class="item-num">{{ changeNum(num3) }}</span>
            <span class="add"></span> <span class="item-unit">个</span> <br />
            项目</span
          >
        </div>
      </div>
    </div> -->
    <!-- <p class="home-title">使用社汇，您可以获得这些</p> -->
    <!-- <div class="content">
      活动管理
      <div class="text-box" style="padding-top: 48px; padding-left: 74px">
        <div class="title">活动管理</div>
        <div class="img-text-box">
          <img
            style="vertical-align: 5px"
            src="https://album.usho.cn/www/upload/4285c4032343ec98d5dfa307138af52e.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">活动管理</span>
            <p class="text-content">
              创建途径多样化，支持在H5、小程序以及管理后台友布活动
            </p>
          </div>
        </div>
        <div class="img-text-box">
          <img
            src="https://album.usho.cn/www/upload/820dfc44568441c990be712cb3219625.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">活动带货</span>
            <p class="text-content">
              开展活动的同时还可以为成员推荐超划算的纪念品
            </p>
          </div>
        </div>
        <div class="img-text-box">
          <img
            src="https://album.usho.cn/www/upload/ceb77df5ed4641ff65dd02d9fa2dfedd.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">管理功能全面</span>
            <p class="text-content">
              陆续研发移动端管理功能，让您的活动管理更便捷
            </p>
          </div>
        </div>
        <div class="img-text-box">
          <img
            style="vertical-align: 10px"
            src="https://album.usho.cn/www/upload/12c6c1878983ca003d51116872d863cc.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">配套服务</span>
            <p class="text-content">
              为您提供活动签到、活动打赏、坐席分配、活动抽奖、分组管理等多种活动配套服务
            </p>
          </div>
        </div>
      </div>
      <img
        :class="{
          'animate__animated  animate__fadeInUp': scrollTop > 700,
          opacity: scrollTop <= 700,
        }"
        style="width: 710px; height: 638px"
        src="https://album.usho.cn/www/upload/d3df5826b2fea700e24491be3a46c120.png?imageView2/1/w/710/h/638/q/10"
        alt=""
      />
      捐赠项目
      <img
        :class="{
          'animate__animated  animate__fadeInUp': scrollTop > 1300,
          opacity: scrollTop <= 1300,
        }"
        style="width: 716px; height: 550px"
        src="https://album.usho.cn/www/upload/838fe41d13298bf636edf2c0ab287d2f.png?imageView2/1/w/796/h/612/q/10"
        alt=""
      />
      <div class="text-box" style="padding-top: 50px; padding-left: 135px">
        <div class="title">捐赠项目</div>
        <div class="img-text-box">
          <img
            src="https://album.usho.cn/www/upload/0f74f2b8a304ba508ae0a0c65f32a5b8.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">在线捐赠</span>
            <p class="text-content">通过互联网快速传播，让捐赠更简单、更直接</p>
          </div>
        </div>
        <div class="img-text-box">
          <img
            style="vertical-align: 5px"
            src="https://album.usho.cn/www/upload/9a631dc8ea1ecaad50212fa9252c1090.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">感恩桥</span>
            <p class="text-content">
              每一次捐赠都值得鸣谢，利用社群系统搭建感恩桥，提升基金会复捐率
            </p>
          </div>
        </div>
        <div class="img-text-box">
          <img
            src="https://album.usho.cn/www/upload/526720b1804a88ff7dbfce0bc14e97c9.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">资金管理</span>
            <p class="text-content">
              有效记录和管理协议、项目资金，实现催款提醒，项目支出控制
            </p>
          </div>
        </div>
        <div class="img-text-box">
          <img
            src="https://album.usho.cn/www/upload/2bb20953555019b2c2102d1bf76f4f9a.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">自动报表</span>
            <p class="text-content">
              据管理数据自动生成协议、项目、资金等多类型报表，用于统计分析
            </p>
          </div>
        </div>
      </div>

      组织建设
      <div class="text-box" style="padding-top: 22px; padding-left: 64px">
        <div class="title">组织建设</div>
        <div class="img-text-box">
          <img
            src="https://album.usho.cn/www/upload/3372dcdd3e80cae4bcff70472991c75c.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">强大的数据库</span>
            <p class="text-content">
              利用大数据管理。智能管理成员及社群数据，科学分析各类数据信息，帮助组织者更好地进行管理
            </p>
          </div>
        </div>
        <div class="img-text-box">
          <img
            src="https://album.usho.cn/www/upload/12dbddf93bf8b1bab8ee176afb865f40.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">成员立体画像</span>
            <p class="text-content">
              拥有批量导入、查重合并、高级查询等功能，可以方便地查询和管理校友的各类数据
            </p>
          </div>
        </div>
        <div class="img-text-box">
          <img
            src="https://album.usho.cn/www/upload/e8d34e7505cdcd7e36bd4a693ef7f44c.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">社群组织管理</span>
            <p class="text-content">
              支持开设各级校友组织、行业俱乐部、院系机构等下属组织，互利共赢，信息实时共享
            </p>
          </div>
        </div>
        <div class="img-text-box">
          <img
            src="https://album.usho.cn/www/upload/1ad42a051b1699fee9ea62d147968457.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">电子校友卡</span>
            <p class="text-content">
              为校友会成员提供定制化的校友身份认证卡片，提升校友对母校的情感，扩大学校影响力
            </p>
          </div>
        </div>
      </div>
      <img
        :class="{
          'animate__animated  animate__fadeInUp': scrollTop > 1800,
          opacity: scrollTop <= 1800,
        }"
        style="width: 717.36px; height: 501.5px"
        src="https://album.usho.cn/www/upload/f4b5a3ea8d402c6218f0c5cf3cfbdb23.png?imageView2/1/w/854/h/590/q/10"
        alt=""
      />

      运营助力
      <img
        :class="{
          'animate__animated  animate__fadeInUp': scrollTop > 2300,
          opacity: scrollTop <= 2300,
        }"
        style="width: 704.7px; height: 501px"
        src="https://album.usho.cn/www/upload/b8d7660bf35a232f30eeaebb3651d9ec.png?imageView2/1/w/783/h/557/q/10"
        alt=""
      />
      <div class="text-box" style="padding-top: 91px; padding-left: 120px">
        <div class="title">运营助力</div>
        <div class="img-text-box">
          <img
            src="https://album.usho.cn/www/upload/3204c3e53c01976604484cc4ec3e015b.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">更多运营工具</span>
            <p class="text-content">
              为您提供群发邮件和短信、纪念相册和视频等多种运营工具，活跃您的组织
            </p>
          </div>
        </div>
        <div class="img-text-box">
          <img
            style="vertical-align: 5px"
            src="https://album.usho.cn/www/upload/88c96ee35aba315ca7856c07aa5eb9c3.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">信息挖掘</span>
            <p class="text-content">
              全网为您搜寻知名组织成员和校友企业，发现身边的行业领袖
            </p>
          </div>
        </div>
        <div class="img-text-box">
          <img
            src="https://album.usho.cn/www/upload/5a90f347e3dcc608a859427b09921bd8.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">价值放大器</span>
            <p class="text-content">捐赠、商城、会费，金流物流都在迸流</p>
          </div>
        </div>
        <div class="img-text-box">
          <img
            src="https://album.usho.cn/www/upload/68580edccecd36be9d816ce58a3907c1.png?imageView2/1/q/40"
            alt=""
          />
          <div class="text-item-box">
            <span class="text-name">“三新”集散地</span>
            <p class="text-content">
              新技术、新媒体、新模式，新新相吸，智慧汇集
            </p>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <p class="home-title2">这些用户正在使用社汇</p> -->

    <!-- <div class="case-box">
      <div
        class="case1-1 case-item"
        :class="{
          'animate__animated  animate__fadeInLeft': scrollTop > 2675,
          opacity: scrollTop <= 2675,
        }"
      ></div>
      <div
        class="case1-2 case-item"
        :class="{
          'animate__animated  animate__fadeInLeft': scrollTop > 2675,
          opacity: scrollTop <= 2675,
        }"
      ></div>
      <div
        class="case1-3 case-item"
        :class="{
          'animate__animated  animate__fadeInLeft': scrollTop > 2675,
          opacity: scrollTop <= 2675,
        }"
      ></div>
      <div
        class="case1-4 case-item"
        :class="{
          'animate__animated  animate__fadeInRight': scrollTop > 2675,
          opacity: scrollTop <= 2675,
        }"
      ></div>
      <div
        class="case1-5 case-item"
        :class="{
          'animate__animated  animate__fadeInRight': scrollTop > 2675,
          opacity: scrollTop <= 2675,
        }"
      ></div>
      <div
        class="case1-6 case-item"
        :class="{
          'animate__animated  animate__fadeInRight': scrollTop > 2675,
          opacity: scrollTop <= 2675,
        }"
      ></div>
    </div> -->
    <!-- <div class="case-box" style="margin-top: 16px">
      <div
        class="case2-1 case-item"
        :class="{
          'animate__animated  animate__fadeInLeft': scrollTop > 2766,
          opacity: scrollTop <= 2766,
        }"
      ></div>
      <div
        class="case2-2 case-item"
        :class="{
          'animate__animated  animate__fadeInLeft': scrollTop > 2766,
          opacity: scrollTop <= 2766,
        }"
      ></div>
      <div
        class="case2-3 case-item"
        :class="{
          'animate__animated  animate__fadeInLeft': scrollTop > 2766,
          opacity: scrollTop <= 2766,
        }"
      ></div>
      <div
        class="case2-4 case-item"
        :class="{
          'animate__animated  animate__fadeInRight': scrollTop > 2766,
          opacity: scrollTop <= 2766,
        }"
      ></div>
      <div
        class="case2-5 case-item"
        :class="{
          'animate__animated  animate__fadeInRight': scrollTop > 2766,
          opacity: scrollTop <= 2766,
        }"
      ></div>
    </div>
    <div class="case-box" style="margin-top: 16px">
      <div
        class="case3-1 case-item"
        :class="{
          'animate__animated  animate__fadeInLeft': scrollTop > 2848,
          opacity: scrollTop <= 2848,
        }"
      ></div>
      <div
        class="case3-2 case-item"
        :class="{
          'animate__animated  animate__fadeInLeft': scrollTop > 2848,
          opacity: scrollTop <= 2848,
        }"
      ></div>
      <div
        class="case3-3 case-item"
        :class="{
          'animate__animated  animate__fadeInLeft': scrollTop > 2848,
          opacity: scrollTop <= 2848,
        }"
      ></div>
      <div
        class="case3-4 case-item"
        :class="{
          'animate__animated  animate__fadeInRight': scrollTop > 2848,
          opacity: scrollTop <= 2848,
        }"
      ></div>
      <div
        class="case3-5 case-item"
        :class="{
          'animate__animated  animate__fadeInRight': scrollTop > 2848,
          opacity: scrollTop <= 2848,
        }"
      ></div>
      <div
        class="case3-6 case-item"
        :class="{
          'animate__animated  animate__fadeInRight': scrollTop > 2848,
          opacity: scrollTop <= 2848,
        }"
      ></div>
    </div> -->

    <!-- <img class="home-bottom-img" src="https://album.usho.cn/www/upload/a6f55a1fd4ceb6174d7cbf15c5019277.png?imageView2/1/q/40" alt="友笑社汇、社汇官网首页、社汇校友管理系统、社汇校友小程app、社汇校友服务平台、社汇校友平台"> -->
    <!-- $router.push('/login')  -->
    <!-- <div class="use" @click="dialogClick('留言信息')">获取方案</div> -->
    <vServicechat ref="child" v-if="showdialog" />
    <!-- <div style="opacity: 0;">社汇校友服务平台：社汇校友管理系统、社汇小程序、社汇网、社汇app、社汇app下载、社汇校友管理系统、社汇校友服务平台、社汇校友平台、友笑社汇、社汇校友小程序、社汇校友服务平台、社汇官网首页</div> -->
  </div>
</template>

<script>
import $ from "jquery";
import vServicechat from '@/components/v-servicechat';
const host = "https://api.sosho.cn";
export default {
  metaInfo: {
    // title: '校友管理系统_社汇校友服务平台 - 社汇官网',
    title: '友笑校友会平台',
    meta: [
      {
        name: 'keywords',
        content: '友笑社汇、社汇官网首页、社汇校友管理系统、社汇小程app、社汇校友服务平台、社汇校友平台'
      },
      {
        name: 'description',
        content: '社汇16年专注校友服务，打造智慧校友管理系统。社汇校友服务平台专为校友会、教育基金会提供运营解决方案，促进教育发展、实现信息化升级。获取方案',
      },
    ]
  },
  components: {
    vServicechat,
  },
  data() {
    return {
      num1: 0,
      num2: 0,
      num3: 0,
      scrollTop: 0,
      showdialog: false,
      is_pc: true,
      img_list: [],
      gif_src: ''
    };
  },
  created() {
    this.isMobile();
    this.getImage();
    this.gif_src = null
    
  },
  mounted() {
    this.gif_src = `https://pics.usho.cn/20241014/1728871839.gif?${new Date().getTime()}`
    document.documentElement.scrollLeft = parseFloat(
      localStorage.getItem("scrollLeft")
    );
    this.scrollTop = document.body.clientHeight - 960;

    window.addEventListener(
      "scroll",
      () => {
        let scrollTop =
          (document.body.scrollTop || document.documentElement.scrollTop) +
          document.body.clientHeight -
          960;
        this.scrollTop = Math.max(scrollTop, this.scrollTop);
        let scrollLeft =
          document.body.scrollLeft || document.documentElement.scrollLeft;
        localStorage.setItem("scrollLeft", scrollLeft);
      },
      true
    );

    let maxNum1 = 80000;
    let timer1 = setInterval(() => {
      this.num1 = this.num1 + maxNum1 / 100;
      if (this.num1 >= maxNum1) {
        this.num1 = maxNum1;
        clearInterval(timer1);
      }
    }, 10);
    let maxNum2 = 20000;
    let timer2 = setInterval(() => {
      this.num2 = this.num2 + maxNum2 / 100;
      if (this.num2 >= maxNum2) {
        this.num2 = maxNum2;
        clearInterval(timer2);
      }
    }, 10);
    let maxNum3 = 2000;
    let timer3 = setInterval(() => {
      this.num3 = this.num3 + maxNum3 / 100;
      if (this.num3 >= maxNum3) {
        this.num3 = maxNum3;
        clearInterval(timer3);
      }
    }, 10);
    if (this.$refs[this.$route.query.scroll]) {
      setTimeout(() => {
        window.scrollTo(0, this.$refs[this.$route.query.scroll].offsetTop - 96)
      }, 1000)
    }
  },
  methods: {
    getImage() {
      $.ajax({
        url: host + "/community/view",
        type: "GET",
        data: {
          appkey: "h5",
          id: 258218,
          carousel_limit: 15
        },
        success: (res) => {
          console.log(res)
          if (res.errno === 0) {
            this.img_list = res.item.carousel;
            console.log(this.img_list)
          }
        },
      });
    },
    isMobile() {
      var system = { win: false, mac: false, xll: false };
      var p = navigator.platform;
      system.win = p.indexOf("Win") == 0;
      system.mac = p.indexOf("Mac") == 0;
      system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
      if (system.win || system.mac || system.xll) {
        this.is_pc = true;
      } else {
        this.is_pc = false;
      }
    },
    changeNum(num) {
      return num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
      });
    },
    dialogClick(title) {
      this.showdialog = true;
      setTimeout(() => {
        this.$refs.child.xcxClick(title);
      }, 100)
    },
    goPW() {
      window.open("https://admin.sosho.cn/#/personal");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only animate__fadeInLeft -->
<style lang="less" scoped>
#home {
  width: 100%;
}

.p_index {
  width: 100%;
  height: 16.5rem;
  position: relative;

  .p_index_bg {
    width: 100%;
    height: 100%;
  }

  .p_index_logo {
    width: 6.17rem;
    height: 1.13rem;
    position: absolute;
    top: 2.01rem;
    left: 2.22rem;
  }

  div {
    width: 5.88rem;
    height: 1.72rem;
    background: linear-gradient(90deg, #FFFFFF 0%, #D4FFFA 100%);
    border-radius: 0.29rem;
    font-weight: 500;
    font-size: 0.86rem;
    color: #006580;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 2.22rem;
    bottom: 2.73rem;
  }
}

.p_index1 {
  width: 100%;
  height: 16.5rem;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }

  div {
    width: 5.88rem;
    height: 1.72rem;
    background: #222222;
    border-radius: 0.29rem;
    font-weight: 500;
    font-size: 0.86rem;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: calc(50% - 2.74rem);
    bottom: 1.36rem;
  }
}

// position: relative;
.banner-style {
  width: 100%;
  height: auto;

  // position: relative;
  img {
    width: 100%;
  }
}

.index_photo {
  width: 100%;
  // height: 776px;
  position: relative;

  .index_photo_banner {
    // min-width: 1920px;
    width: 100%;
    height: auto;
    display: block;
  }

  .index_photo_gif {
    width: 165px;
    height: 33px;
    position: absolute;
    left: 19.4%;
    bottom: 73.1%;
  }

  div {
    width: 184px;
    height: 48px;
    background: linear-gradient(270deg, #C6F7FF 0%, #FFFFFF 100%);
    border-radius: 8px;
    position: absolute;
    left: 19.4%;
    bottom: 22%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #006580;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}

.index_photo1 {
  width: 100%;
  // min-width: 1920px;
  // height: 724px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    // min-width: 1920px;
    width: 100%;
    height: auto;
  }

  .index_photo1_title {
    font-family: OPPOSans, OPPOSans;
    font-weight: normal;
    font-size: 46px;
    color: #232125;
    margin-top: 46rpx;
    position: absolute;
    top: 5%;
    left: 50%;
    transform: translate(-50%);

  }

  .info1 {
    position: absolute;
    top: 31.3%;
    left: 55.1%;

    span {
      font-family: D-DIN-PRO, D-DIN-PRO;
      font-weight: 800;
      font-size: 26px;
      color: #232125;
      margin-bottom: 9px;
    }

    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #232125;
      line-height: 24px;
    }
  }

  .info2 {
    position: absolute;
    top: 55.2%;
    left: 55.1%;

    span {
      font-family: D-DIN-PRO, D-DIN-PRO;
      font-weight: 800;
      font-size: 26px;
      color: #232125;
      margin-bottom: 9px;
    }

    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #232125;
      line-height: 24px;
    }
  }

  .get_programme {
    width: 184px;
    height: 48px;
    background: #222222;
    border-radius: 8px;
    position: absolute;
    left: calc(50% - 92px);
    bottom: 17.8%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

  }
}

.index_photo2 {
  width: 100%;
  // min-width: 1920px;
  // height: 724px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    // min-width: 1920px;
    width: 100%;
    height: auto;
  }

  .index_photo2_title {
    font-weight: normal;
    font-size: 46px;
    color: #232125;
    margin-top: 46rpx;
    position: absolute;
    top: 46px;
    left: 50%;
    transform: translate(-50%);
  }

  .info1 {
    position: absolute;
    top: 31.3%;
    left: 28.7%;

    span {
      font-weight: 800;
      font-size: 26px;
      color: #232125;
      margin-bottom: 9px;
    }

    p {
      font-weight: 400;
      font-size: 16px;
      color: #232125;
      line-height: 24px;
    }
  }

  .info2 {
    position: absolute;
    top: 55.2%;
    left: 28.7%;

    span {
      font-weight: 800;
      font-size: 26px;
      color: #232125;
      margin-bottom: 9px;
    }

    p {
      font-weight: 400;
      font-size: 16px;
      color: #232125;
      line-height: 24px;
    }
  }

  .get_programme {
    width: 184px;
    height: 48px;
    background: #222222;
    border-radius: 8px;
    position: absolute;
    left: calc(50% - 92px);
    bottom: 16.7%;
    font-weight: 600;
    font-size: 20px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

  }
}

.banner {
  width: 1200px;
  // width: 100%;
  margin: 0 auto;
  height: auto;
  position: relative;

  .content-flex {
    width: 1366px;
    height: 282px;
    background: #ffffff;
    box-shadow: 0px 10px 15px 0px rgba(222, 228, 243, 0.5);
    border-radius: 24px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 999;
    margin-left: -683px;
    margin-top: -341px;

    .flex-one,
    .flex-two {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;
      height: 218px;

      // margin: 32px 0 32px 103px;
      img {
        height: 56px;
      }

      .title-small {
        text-align: center;
        width: 100%;
        // font-weight: bold;
        font-size: 20px;

        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }

      .text {
        width: 480px;
        // margin-left: 50px;
        height: 44px;
        font-size: 16px;

        font-weight: 400;
        color: #999999;
        line-height: 22px;
      }

      .ljsy {
        display: flex;
        justify-content: center;

        .ljsy-one,
        .ljsy-two {
          cursor: pointer;
          width: 184px;
          height: 48px;
          border-radius: 8px;
          font-size: 20px;

          font-weight: 500;
          color: #ffffff;
          line-height: 48px;
        }
      }
    }
  }

  .img1-text {
    position: absolute;
    z-index: 100;
    font-size: 14px;

    font-weight: 500;
    color: #eacb8e;
    top: 92px;
    right: 581px;
    background-color: rgba(255, 255, 255);
    padding: 7px 14px;
    transform: rotate(-31deg);
    -ms-transform: rotate(-31deg);
    /* IE 9 */
    -moz-transform: rotate(-31deg);
    /* Firefox */
    -webkit-transform: rotate(-31deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(-31deg);
    /* Opera */
    border-top-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .img2-text {
    position: absolute;
    z-index: 100;
    font-size: 14px;

    font-weight: 500;
    color: #eacb8e;
    top: 115px;
    right: 289px;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 7px 14px;
    transform: rotate(-30deg);
    -ms-transform: rotate(-30deg);
    /* IE 9 */
    -moz-transform: rotate(-30deg);
    /* Firefox */
    -webkit-transform: rotate(-30deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(-30deg);
    /* Opera */
    border-top-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .img3-text {
    position: absolute;
    z-index: 100;
    font-size: 14px;

    font-weight: 500;
    color: #4eb7cc;
    top: 311px;
    right: 448px;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 7px 14px;
    transform: rotate(-31deg);
    -ms-transform: rotate(-31deg);
    /* IE 9 */
    -moz-transform: rotate(-31deg);
    /* Firefox */
    -webkit-transform: rotate(-31deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(-31deg);
    /* Opera */
    border-top-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .img4-text {
    position: absolute;
    z-index: 100;
    font-size: 14px;

    font-weight: 500;
    color: #4eb7cc;
    top: 343px;
    right: 146px;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 7px 14px;
    transform: rotate(-30deg);
    -ms-transform: rotate(-30deg);
    /* IE 9 */
    -moz-transform: rotate(-30deg);
    /* Firefox */
    -webkit-transform: rotate(-30deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(-30deg);
    /* Opera */
    border-top-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .yellow-line {
    width: 216px;
    height: 13px;
    background: #ffe195;
    border-radius: 8px;
  }

  .title {
    font-size: 54px;
    font-family: OPPOSans-B, OPPOSans;
    font-weight: normal;
    color: rgba(0, 0, 0, 0.85);
    line-height: 63px;
    letter-spacing: 1px;
    position: absolute;
    top: 125px;
  }

  .text {
    font-size: 16px;

    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
    // margin-top: 96px;
  }

  .free-use {
    width: 184px;
    height: 56px;
    background: #31cec2;
    border-radius: 8px;
    border: 10px solid rgba(49, 206, 194, 0.1);
    text-align: center;
    line-height: 40px;
    font-size: 20px;

    font-weight: 500;
    color: #ffffff;
    cursor: pointer;
    margin-top: 80px;
    box-sizing: border-box;
  }

  .img1 {
    position: absolute;
    top: 10px;
    right: 374px;
    width: 330px;
    height: 330px;
  }

  .img2 {
    position: absolute;
    top: 31px;
    right: 70px;
    width: 330px;
    height: 330px;
  }

  .img3 {
    position: absolute;
    top: 230px;
    right: 243px;
    width: 330px;
    height: 330px;
  }

  .img4 {
    position: absolute;
    top: 260px;
    right: -60px;
    width: 330px;
    height: 330px;
  }

  .item {
    width: 378px;
    height: 184px;
    // background: #f7f8fc;
    border-radius: 24px;
    display: inline-block;
    vertical-align: top;
    margin-top: 127px;
    padding: 40px 32px;
    box-sizing: border-box;
    margin-left: 20px;

    .item-img {
      width: 104px;
      height: 104px;
      margin-right: 19px;
      display: inline-block;
    }

    .item-text {
      vertical-align: 10px;
      display: inline-block;
      font-size: 20px;

      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);

      .item-num {
        font-size: 36px;
        font-family: DINPro-Regular, DINPro;
        font-weight: 400;
      }

      .add {
        font-size: 24px;
        line-height: 24px;
        display: inline-block;
        vertical-align: 8px;
      }

      .item-unit {
        font-size: 16px;

        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }
}

.home-title {
  font-size: 48px;

  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 56px;
  padding-top: 47px;
  padding-bottom: 90px;
  text-align: center;
}

.home-title2 {
  font-size: 48px;

  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 56px;
  padding-top: 104px;
  padding-bottom: 49px;
  text-align: center;
}

.home-bottom-img {
  width: 1239px;
  height: 252px;
  display: block;
  margin: 0 auto;
}

.use {
  width: 240px;
  height: 56px;
  background: #31cec2;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 39px;
  margin-bottom: 104px;
  text-align: center;
  line-height: 56px;
  font-size: 20px;

  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
}

.content {
  margin: 0 auto;
  margin-top: 80px;
  width: 1440px;
}

.content .text-box {
  display: inline-block;
  vertical-align: top;
  width: 710px;
  box-sizing: border-box;
}

.content .text-box .title {
  font-size: 40px;

  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 20px;
}

.img-text-box {
  margin-top: 20px;
}

.img-text-box img {
  width: 48px;
  height: 48px;
  display: inline-block;
}

.img-text-box .text-item-box {
  margin-left: 28px;
  display: inline-block;
}

.img-text-box .text-item-box .text-name {
  font-size: 20px;

  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}

.img-text-box .text-item-box .text-content {
  font-size: 16px;

  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  width: 412px;
}

.case-box {
  height: auto;
  width: 1240px;
  margin: 0 auto;

  .case-item {
    margin-left: 17px;

    height: 60px;
    background: #ffffff;
    box-shadow: 5px 5px 20px 0px #e3e9fa;
    border-radius: 8px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
    display: inline-block;
  }

  .case1-1 {
    margin-left: 0px;
    width: 236px;
    //background-image: url('https://album.usho.cn/www/upload/b3cbf2f926e00877746065eba198561c.png');
    //&:hover{
    background-image: url("https://album.usho.cn/www/upload/9b4a99b5b5c0ae8b8d9e215effab4db6.png");
    //}
  }

  .case1-2 {
    width: 181px;
    //background-image: url('https://album.usho.cn/www/upload/19657f36ab5daf42e42b5a0953ca2233.png');
    //&:hover{
    background-image: url("https://album.usho.cn/www/upload/d698a5b937506c986c5e5f0323b839fc.png");
    //}
  }

  .case1-3 {
    width: 187px;
    //background-image: url('https://album.usho.cn/www/upload/4f6bb07e3bb30924cce16e9fdb7bca22.png');
    //&:hover{
    background-image: url("https://album.usho.cn/www/upload/302e525d77bd21a84fd473efd2bf444c.png");
    //}
  }

  .case1-4 {
    width: 183px;
    //background-image: url('https://album.usho.cn/www/upload/b9ff9686271a69495c79d78fb8b508c4.png');
    //&:hover{
    background-image: url("https://album.usho.cn/www/upload/c3cdcac71c65e574809188db505f2719.png");
    //}
  }

  .case1-5 {
    width: 184px;
    //background-image: url('https://album.usho.cn/www/upload/813e114b1a1ff081937115b5eb2e5ce0.png');
    //&:hover{
    background-image: url("https://album.usho.cn/www/upload/8f722882dc96b0fc18e2223885ecf57c.png");
    //}
  }

  .case1-6 {
    width: 152px;
    //background-image: url('https://album.usho.cn/www/upload/891a6c100e272ee3dbe14a6f563efaf5.png');
    //&:hover{
    background-image: url("https://album.usho.cn/www/upload/5e9e836b632ffa240d6b12b5186b990c.png");
    //}
  }

  .case2-1 {
    margin-left: 70px;
    width: 199px;
    //background-image: url('https://album.usho.cn/www/upload/38d75124216a2bea0e810f62fd70dfa1.png');
    // &:hover{
    background-image: url("https://album.usho.cn/www/upload/cbf90b0698bd89ca4e8d8a75165bd643.png");
    //}
  }

  .case2-2 {
    width: 137px;
    //background-image: url('https://album.usho.cn/www/upload/ed78ed53b0afabd4c5bf2acc1024366f.png');
    // &:hover{
    background-image: url("https://album.usho.cn/www/upload/73708aaed153504eb6ed8b59eb05fece.png");
    //}
  }

  .case2-3 {
    width: 171px;
    //background-image: url('https://album.usho.cn/www/upload/caeb99afe59e9f4b372cb8d6654131be.png');
    // &:hover{
    background-image: url("https://album.usho.cn/www/upload/fbfad2e70e5a3e6452a98185bc625b08.png");
    //}
  }

  .case2-4 {
    width: 179px;
    //background-image: url('https://album.usho.cn/www/upload/db72ff28b305a96d2f721b9b01cfb1b4.png');
    //&:hover{
    background-image: url("https://album.usho.cn/www/upload/17bd14d0cdb4f8f6f3daeaedefce7553.png");
    //}
  }

  .case2-5 {
    width: 289px;
    // background-image: url('https://album.usho.cn/www/upload/ba9f70b6e4f75e87beff8996f26e5707.png');
    // &:hover{
    background-image: url("https://album.usho.cn/www/upload/a5f8378c858396d347caeef1b86776fe.png");
    //}
  }

  .case3-1 {
    margin-left: 0;
    width: 198px;
    // background-image: url('https://album.usho.cn/www/upload/98385d7abe7488bc8971da7a83c21d42.png');
    // &:hover{
    background-image: url("https://album.usho.cn/www/upload/3f2c1cc052905d84602a42838ce7c40b.png");
    //}
  }

  .case3-2 {
    width: 178px;
    // background-image: url('https://album.usho.cn/www/upload/afae081c75c0006520009c319dca738e.png');
    // &:hover{
    background-image: url("https://album.usho.cn/www/upload/1d484d24cc9c167ba67d6f8001a17052.png");
    //}
  }

  .case3-3 {
    width: 211px;
    // background-image: url('https://album.usho.cn/www/upload/80c427f58f86c88ac260e58aeaf7437f.png');
    // &:hover{
    background-image: url("https://album.usho.cn/www/upload/7cb5c540d819b9203542ceb8e2b98cf7.png");
    //}
  }

  .case3-4 {
    width: 161px;
    // background-image: url('https://album.usho.cn/www/upload/20541149052de687047ce745c238cbc0.png');
    // &:hover{
    background-image: url("https://album.usho.cn/www/upload/c4c6fbdc15bebb3c0b8cf311ee1d3358.png");
    //}
  }

  .case3-5 {
    width: 175px;
    // background-image: url('https://album.usho.cn/www/upload/22e2ee76ead7f478133fae9f9760095b.png');
    // &:hover{
    background-image: url("https://album.usho.cn/www/upload/dca2bf2d4a3e1fbe049af0d11ca1e31e.png");
    //}
  }

  .case3-6 {
    width: 199px;
    // background-image: url('https://album.usho.cn/www/upload/a52ca807933bf4e6e8dc95e1fd6acda3.png');
    // &:hover{
    background-image: url("https://album.usho.cn/www/upload/7088f28f2c93db420cb3a0b385674b0e.png");
    //}
  }
}

.phone {
  // width: 432px;
  height: 80px;
  background: #fafafa;
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .kefu {

    // padding-top: 23px;
    .kefu-phone {
      padding-top: 8px;
      height: 20px;
      font-size: 14px;

      font-weight: 400;
      color: #00bbad;
      line-height: 20px;
    }
  }

  .wechat-big {
    // padding-top: 12px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .kefu-phone {
      padding-top: 8px;
      height: 20px;
      font-size: 14px;

      font-weight: 400;
      color: #00bbad;
      line-height: 20px;
    }

    img {
      display: flex;
      align-items: center;
      height: 64px;
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home.vue